function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.11992 15.5907L7.54866 15.7144C8.77321 15.7585 9.41834 14.5095 8.74523 13.4553C8.29167 12.7118 8.49008 11.8102 9.11334 11.4086C10.5363 10.5512 13.7742 10.6074 15.481 11.6383C16.2589 12.0299 16.6187 13.0123 16.3374 13.7292C15.9085 14.7436 16.8552 16.0501 18.0798 16.0943L21.5085 16.218C22.4198 16.1903 23.0683 15.4866 22.9678 14.6348L22.6949 12.3227C22.3536 9.94753 17.593 7.83703 11.8376 7.6294C6.08218 7.42176 1.71271 9.14227 1.99999 11.5761L2.27288 13.8882C2.44181 14.8031 3.26271 15.5598 4.11992 15.5907Z",
  fill: "#E25141"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 18.6667,
  fill: "white",
  transform: "translate(24.7305 13.4434) rotate(132.667)"
})));

var SvgPhoneCall = function SvgPhoneCall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneCall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone-call.12e4ed4e.svg";
export { ForwardRef as ReactComponent };